import { AdminDashboardStatKeyPayload } from "@bracket/idl/main/admin/payload/AdminDashboardPayloadPt"

/**
 * 관리자 대시보드 UI 모델.
 *
 * 서버는 집계 **값과 종류(key)** 만 내려주고, 아이콘 · 색은 화면이 정한다 —
 * 표시 스타일을 API 로 나르면 디자인을 고칠 때 서버를 배포해야 한다.
 */
/** 지표 톤 — 색 이름이 아니라 의도로 둔다 (실제 색은 화면이 정한다) */
type AdminStatTone = "brand" | "neutral" | "attention" | "positive"

interface AdminDashboardStat {
  key: AdminDashboardStatKeyPayload
  label: string
  value: string
  detail: string
  /** components/common/Icon.tsx 의 아이콘 이름 */
  icon: string
  tone: AdminStatTone
}

interface AdminRecentEntry {
  entryNo: string
  playerName: string
  gymName: string
  category: string
  appliedAtText: string
  statusLabel: string
}

interface AdminDashboardSummary {
  managerName: string
  stats: AdminDashboardStat[]
  recentEntries: AdminRecentEntry[]
}

interface AdminStatPresentation {
  label: string
  detail: string
  icon: string
  tone: AdminStatTone
}

/** 집계 종류별 표시 규칙 — 서버 key 를 화면 문구 · 아이콘으로 옮긴다 */
const STAT_PRESENTATIONS: Record<
  AdminDashboardStatKeyPayload,
  AdminStatPresentation
> = {
  [AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_UNKNOWN]: {
    label: "알 수 없음",
    detail: "",
    icon: "clipboard",
    tone: "brand",
  },
  [AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_ENTRY_COUNT]: {
    label: "참가 신청",
    detail: "취소된 신청은 제외한 건수입니다.",
    icon: "clipboard",
    tone: "brand",
  },
  [AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_PLAYER_COUNT]: {
    label: "신청 선수",
    detail: "반려된 선수는 제외했습니다.",
    icon: "users",
    tone: "neutral",
  },
  [AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_APPROVAL_WAITING_COUNT]: {
    label: "승인 대기 선수",
    detail: "심사가 필요한 선수 수입니다.",
    icon: "scale",
    tone: "attention",
  },
  [AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_OPEN_TOURNAMENT_COUNT]: {
    label: "접수 중 대회",
    detail: "접수 중 · 진행 중인 대회 수입니다.",
    icon: "trophy",
    tone: "positive",
  },
  [AdminDashboardStatKeyPayload.UNRECOGNIZED]: {
    label: "알 수 없음",
    detail: "",
    icon: "clipboard",
    tone: "brand",
  },
}

function statPresentation(
  key: AdminDashboardStatKeyPayload,
): AdminStatPresentation {
  return (
    STAT_PRESENTATIONS[key] ??
    STAT_PRESENTATIONS[
      AdminDashboardStatKeyPayload.ADMIN_DASHBOARD_STAT_UNKNOWN
    ]
  )
}

export { STAT_PRESENTATIONS, statPresentation }
export type {
  AdminDashboardStat,
  AdminDashboardSummary,
  AdminRecentEntry,
  AdminStatTone,
}
